import get from 'transmute/get';
import { VISITOR_ID } from '../constants/keyPaths';
export const getVisitorId = get(VISITOR_ID);